var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_195_32042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 10,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10156 0.143037L8.48406 7.52475L10.7968 5.21196L1.78366 0.256453C1.60917 0.160484 1.4434 0.11528 1.29508 0.11528C1.22608 0.114487 1.16105 0.124002 1.10156 0.143037Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_195_32042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58978 9.6431L-0.517578 0.487147L10.3087 -2.00488L12.4161 7.15107L1.58978 9.6431Z",
    fill: "url(#paint0_linear_195_32042)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_195_32042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 7,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48242 7.52177L10.8071 9.84645L13.8837 8.15469C14.5079 7.80968 14.5079 7.25051 13.8837 6.90709L10.796 5.20898L8.48242 7.52177Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_195_32042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9694 2.58398L16.5298 8.66416L10.0213 12.4752L6.46094 6.395L12.9694 2.58398Z",
    fill: "url(#paint1_linear_195_32042)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_195_32042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 9,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.650391 0.924426L0.651976 14.1389C0.651976 14.5545 0.824082 14.8273 1.08978 14.9185L8.48418 7.5241L1.10168 0.141602C0.828053 0.226467 0.650391 0.504857 0.650391 0.924426Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_195_32042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14476 16.8226L-2.9375 1.07252L7.99269 -1.75977L12.0742 13.9895L1.14476 16.8226Z",
    fill: "url(#paint2_linear_195_32042)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_195_32042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 7,
    width: 10,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0918 14.9217C1.28374 14.9876 1.52406 14.9566 1.78579 14.8131L10.8101 9.85044L8.4862 7.52734L1.0918 14.9217Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_195_32042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.814 14.85L1.27162 16.2943L0.0898438 7.665L10.6314 6.2207L11.814 14.85Z",
    fill: "url(#paint3_linear_195_32042)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_195_32042",
    x1: 6.67707,
    y1: 6.98398,
    x2: 4.09857,
    y2: -4.22039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2959,
    stopColor: "#9AE5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9764,
    stopColor: "#05A5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_195_32042",
    x1: 6.63218,
    y1: -0.774818,
    x2: 13.2312,
    y2: 10.4955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF177B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0081,
    stopColor: "#FF197B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6996,
    stopColor: "#FFAF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_195_32042",
    x1: 5.4583,
    y1: 10.9612,
    x2: 1.46963,
    y2: -4.42852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4842,
    stopColor: "#32A0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8345,
    stopColor: "#1262A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_195_32042",
    x1: 12.7063,
    y1: 10.3305,
    x2: -1.11922,
    y2: 12.2244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3472,
    stopColor: "#D43E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7952,
    stopColor: "#9F36BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A33DB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreIcon);
export default __webpack_public_path__ + "static/media/PlaystoreIcon.da64276f03e05cbade46204c892e1b49.svg";
export { ForwardRef as ReactComponent };